// 登录
export function login(data) {
  return this.fetch({
    method: 'post',
    url: 'api/login',
    data
  })
    .then(async result => {
      if (result.code === 30208) {
        return result
      } else {
        return result
      }
    })
    .catch(e => {
      return {
        isError: true,
        errorMsg: e.message
      }
    })
}
export function logout() {
  return this.fetch({
    method: 'get',
    url: 'api/logout'
  })
    .then(() => {
      this.clearUserState()
    })
    .catch(() => {
      this.clearUserState()
    })
}

// 用户状态
export function getUserInfo(params) {
  return this.fetch({
    method: 'get',
    url: 'api/getUserInfo',
    params
  }).then(userInfo => {
    this.setUserState(userInfo)
  })
}
// 判断当前账号的所属公司是否是顶级公司
export function isTopPartner() {
  return this.fetch({
    method: 'get',
    url: 'api/dsp/adDspPartner/isTopPartner'
  }).then(data => {
    this.state.isTopPartner = data.isTopPartner
  })
}

export function setUserState(data = {}) {
  const user = {
    userName: data.userName, // 用户名称
    userAccount: this.$decrypt(data.userAccount), // 登录账号
    phone: this.$decrypt(data.phone),
    email: this.$decrypt(data.email),
    accountType: data.accountType,
    accountTypeName: ['广告主', '代理商'][data.accountType],
    partnerId: data.partnerId,
    isTopPartner: data.isTopPartner
  }
  this.state.token = data.tokenId
  this.state.user = user
}

export function clearUserState() {
  this.state.user = {}
  this.state.token = undefined
  this.state.isTopPartner = undefined
  // AppState.loginPermissionsInfo = {}
}

// 验证码
export function sendCode(data) {
  return this.fetch({
    method: 'post',
    url: 'api/code',
    data,
    useLoading: false
  })
}

export function checkPicCode(params) {
  return this.fetch({
    method: 'get',
    url: 'api/checkCode',
    params
  })
}

// export function checkSmsCode (params) {
//   return this.fetch({
//     method: 'get',
//     url: 'api/checkSmsCode',
//     params
//   })
// }

// 密码
export function resetPassword(data) {
  return this.fetch({
    method: 'post',
    url: 'api/resetPassword',
    data
  })
}

export function forgetPassword(data) {
  return this.fetch({
    method: 'post',
    url: 'api/forgetPassword',
    data
  })
}

// 用户信息更改
export function updateUsername(data) {
  return this.fetch({
    method: 'post',
    url: 'api/updateUsername',
    data
  })
}

export function updatePhoneOrEmail(data) {
  return this.fetch({
    method: 'post',
    url: 'api/updatePhoneOrEmail',
    data
  })
}

// 注册保存接口
export function registerSave(data) {
  return this.fetch({
    method: 'post',
    url: 'api/register',
    data
  })
}
// 登录日志
export function getUserLog(params) {
  return this.fetch({
    method: 'get',
    url: 'api/getUserLog',
    params
  })
}
// 验证手机号是否已经注册
// export function checkPhoneRegistered(data) {
//   return this.fetch({
//     method: 'post',
//     url: 'api/',
//     data
//   })
// }
// 验证验证码是否填写正确
export function checkCode(params) {
  return this.fetch({
    method: 'get',
    url: 'api/checkCode',
    params
  })
    .then(data => {
      return data
    })
    .catch(e => {
      return {
        isError: true,
        errorMsg: e.message
      }
    })
}
// 发送的短信或邮箱验证码验证
export function checkSmsCode(params) {
  return this.fetch({
    method: 'get',
    url: 'api/checkSmsCode',
    params
  })
    .then(data => {
      return data
    })
    .catch(e => {
      return {
        isError: true,
        errorMsg: e.message
      }
    })
}
// 注册环节 验证手机号是否已经注册
export function checkRegister(params) {
  return this.fetch({
    method: 'get',
    url: 'api/checkRegister',
    params
  })
}
// 账号管理 验证手机号是否已经存在
export function checkPhone(data) {
  return this.fetch({
    method: 'post',
    url: 'api/checkPhone',
    data
  }).catch(e => {
    return {
      isError: true,
      errorMsg: e.message
    }
  })
}

// 验证登录账号
export function checkAccount(data) {
  return this.fetch({
    method: 'post',
    url: 'api/checkAccount',
    data
  })
    .then(data => {
      return data
    })
    .catch(e => {
      return {
        isError: true,
        errorMsg: e.message
      }
    })
}
// 更新登录账号
export function updateAgentAccount(data) {
  return this.fetch({
    method: 'post',
    url: 'api/updateAgentAccount',
    data
  })
}
// 填写邮件
export function addEmail(data) {
  return this.fetch({
    method: 'post',
    url: 'api/addEmail',
    data
  })
}
// 注册登录调用地址库
export function getRegistRegionList(data) {
  return this.fetch({
    method: 'get',
    url: 'api/getRegionList',
    data
  })
}
// 获取系统牌照方
export function getSystemTag(params) {
  return this.fetch({
    method: 'get',
    url: 'api/getSystemTag',
    params
  })
}

// 身份验证
export function authLogin(data) {
  return this.fetch({
    method: 'post',
    url: 'api/loginAuth',
    data
  })
}
